import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Typography } from "@mui/material";
import { BasicsInfoStyled } from "./basic-info.style";
import { fetchLinkedCompanies } from "../../../../services/projectsServices";

import CompanyInfoForm, {
  Company_INFO_FORM_VIEW_TYPES,
} from "../../companies-info-form";
import LinkedContactsTable from "./linked-contacts/linked-contacts";

const BasicInfo = ({ companyData, isEditMode, form }) => {
  const [clientsList, setClientsList] = useState([]);
  const { isDirty } = form.formState;

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isEditMode && isDirty) {
        const message = "Hold on! Your changes have not been saved.";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isEditMode, isDirty]);
  const { data: linkedProjects = [] } = useQuery({
    queryKey: ["linked-projects", companyData.companyID],
    queryFn: () => fetchLinkedCompanies(companyData.companyID),
  });

  const hasActiveLinkedProjects = linkedProjects.some(
    (p) => p.state === "Active"
  );
  return (
    <BasicsInfoStyled>
      <div
        className="company-form"
        style={{
          pointerEvents: isEditMode ? "" : "none",
          opacity: isEditMode ? "1.0" : "0.7",
        }}
      >
        <CompanyInfoForm
          companyData={companyData}
          form={form}
          view={Company_INFO_FORM_VIEW_TYPES.detail}
          clientOptions={clientsList}
          disableStateField={hasActiveLinkedProjects}
        />
      </div>
      <div>
        <Typography variant="h6" className="type">
          Company Contacts
        </Typography>
        <LinkedContactsTable
          companyID={companyData.companyID}
          companyName={companyData.companyName}
        />
      </div>
    </BasicsInfoStyled>
  );
};

export default BasicInfo;
